import { useMediaQuery } from './hooks'
import { breakpoints, Break } from 'cms-web-styleguide/dist/utils/constants'
import type { FC, PropsWithChildren } from 'react'

interface MediaQueryProps extends PropsWithChildren {
  min?: Break
  max?: Break
}

const MediaQuery: FC<MediaQueryProps> = (props) => {
  const { children, min, max } = props

  const minBreakpoint = breakpoints[min ?? 'xs']
  const maxBreakpoint = breakpoints[max ?? 'xl']

  const isAppropriateSize = useMediaQuery({ min: minBreakpoint.min }, { max: maxBreakpoint.max ?? undefined })
  if (isAppropriateSize) {
    return <>{children}</>
  }

  return null
}

export default MediaQuery
